module.exports = __webpack_public_path__ + "static/media/YB5M15_3.fedfc1cd.jpg";